import React from 'react';

interface LoadingSpinnerProps {
  label?: string;
  size?: 'xs' | 'sm' | 'md' | 'lg';
  className?: string;
}

export const LoadingSpinner: React.FC<LoadingSpinnerProps> = ({
  label = 'Loading...',
  size = 'md',
  className = '',
}) => {
  const sizeClasses = {
    xs: 'w-4 h-4',
    sm: 'w-6 h-6', 
    md: 'w-8 h-8',
    lg: 'w-12 h-12',
  };

  return (
    <div className={`flex flex-col justify-center items-center py-10 px-5 min-h-[120px] ${className}`}>
      <div 
        className={`${sizeClasses[size]} border-4 border-gray-200 border-t-blue-600 rounded-full animate-spin`}
        role="progressbar"
        aria-label={label}
      ></div>
      {label && (
        <p className="text-gray-500 mt-3 text-sm">{label}</p>
      )}
    </div>
  );
};
